const BATCH_STORAGE_PREFIX = "proofreading-ai-batch:";

export type StoredAiProofreadingBatch = {
  batchId: string;
  createdAt: number;
};

export function buildAiProofreadingBatchStorageKey(novelId: string): string {
  return `${BATCH_STORAGE_PREFIX}${novelId}`;
}

export function loadStoredAiProofreadingBatch(novelId: string): StoredAiProofreadingBatch | null {
  if (typeof window === "undefined" || !novelId) return null;
  try {
    const raw = window.localStorage.getItem(buildAiProofreadingBatchStorageKey(novelId));
    if (!raw) return null;
    const parsed = JSON.parse(raw) as StoredAiProofreadingBatch;
    if (typeof parsed.batchId !== "string" || typeof parsed.createdAt !== "number") {
      return null;
    }
    return parsed;
  } catch {
    return null;
  }
}

export function saveStoredAiProofreadingBatch(
  novelId: string,
  batchId: string,
): StoredAiProofreadingBatch {
  const payload: StoredAiProofreadingBatch = {
    batchId,
    createdAt: Date.now(),
  };
  if (typeof window !== "undefined" && novelId) {
    window.localStorage.setItem(
      buildAiProofreadingBatchStorageKey(novelId),
      JSON.stringify(payload),
    );
  }
  return payload;
}

export function clearStoredAiProofreadingBatch(novelId: string): void {
  if (typeof window === "undefined" || !novelId) return;
  window.localStorage.removeItem(buildAiProofreadingBatchStorageKey(novelId));
}
